// import React, { useCallback, useEffect } from "react";
// import css from "./info.module.css";
// import srvd from "../../img/aboutPic.png"; // якщо не використовуєте — можна видалити
// void srvd;

// export default function Delivery() {
//   const SCROLL_MARGIN = 12;

//   const getVisibleHeaderHeight = () => {
//     const header =
//       document.querySelector("[data-fixed-header]") ||
//       document.querySelector("header");
//     if (!header) return 0;
//     const r = header.getBoundingClientRect();
//     // видима висота у вікні: якщо хедер поїхав вгору (translateY), r.bottom буде <=
//     const visible = Math.max(
//       0,
//       Math.min(r.height, r.bottom) - Math.max(0, r.top)
//     );
//     return Math.round(visible);
//   };

//   const scrollToId = useCallback((id) => {
//     const el = document.getElementById(id);
//     if (!el) return;

//     const firstHeader = getVisibleHeaderHeight();
//     const target =
//       el.getBoundingClientRect().top +
//       window.pageYOffset -
//       (firstHeader + SCROLL_MARGIN);

//     window.scrollTo({ top: target, behavior: "smooth" });

//     // Оновлюємо URL-хеш без перезавантаження
//     const base = window.location.pathname + window.location.search;
//     window.history.replaceState(null, "", `${base}#${id}`);

//     // 1-ша корекція після ймовірного приховування/стиснення хедера
//     setTimeout(() => {
//       const nowHeader = getVisibleHeaderHeight();
//       const delta =
//         el.getBoundingClientRect().top - (nowHeader + SCROLL_MARGIN);
//       if (Math.abs(delta) > 1)
//         window.scrollBy({ top: delta, behavior: "auto" });
//     }, 350);

//     // 2-га корекція на випадок довшої анімації хедера
//     setTimeout(() => {
//       const nowHeader = getVisibleHeaderHeight();
//       const delta =
//         el.getBoundingClientRect().top - (nowHeader + SCROLL_MARGIN);
//       if (Math.abs(delta) > 1)
//         window.scrollBy({ top: delta, behavior: "auto" });
//     }, 700);
//   }, []);

//   const handleAnchor = useCallback(
//     (e) => {
//       const href = e.currentTarget.getAttribute("href");
//       if (!href || !href.startsWith("#")) return;
//       e.preventDefault();
//       scrollToId(href.slice(1));
//     },
//     [scrollToId]
//   );

//   // Якщо зайшли одразу з хешем — прокручуємо точно
//   useEffect(() => {
//     if (window.location.hash && window.location.hash.startsWith("#")) {
//       const id = window.location.hash.slice(1);
//       // невелика пауза, щоб DOM порахував висоти/класи хедера
//       setTimeout(() => scrollToId(id), 0);
//     }
//   }, [scrollToId]);

//   return (
//     <div className={css.aboutWrapAll}>
//       <div className={css.smallWrapAbout}>
//         <nav className={css.wrapTwoButton} aria-label="Навігація по сторінці">
//           <a
//             className={css.aboutCompanyH1One}
//             href="#delivery"
//             onClick={handleAnchor}
//           >
//             Доставка
//           </a>{" "}
//           <a
//             className={css.aboutCompanyH1One}
//             href="#payment"
//             onClick={handleAnchor}
//           >
//             Оплата
//           </a>
//           <a
//             className={css.aboutCompanyH1One}
//             href="#pickup"
//             onClick={handleAnchor}
//           >
//             Самовивіз
//           </a>
//           <a
//             className={css.aboutCompanyH1Two}
//             href="#where"
//             onClick={handleAnchor}
//           >
//             Де побачити наші книги
//           </a>{" "}
//           <a
//             className={css.aboutCompanyH1Thre}
//             href="#other-resources"
//             onClick={handleAnchor}
//           >
//             Книги ЧМ на інших ресурсах
//           </a>{" "}
//         </nav>

//         {/* Доставка */}
//         <div
//           id="delivery"
//           className={`${css.buttonGrenDostavka} ${css.anchorTarget}`}
//         >
//           Доставка
//         </div>
//         <div className={css.wrapTwoOffer}>
//           <p className={css.firstDogovir}>
//             Ціни, зазначені на сайті, є остаточними й не вимагають доплат при
//             стандартних умовах постачання. Усі податки входять у вартість
//             товару. Так само пакування замовлень повністю на видавництві - ви не
//             платите при доставці нічого додатково! Доставка по Україні: Книжки,
//             замовлені в інтернет-магазині, надсилаємо виключно компанією "Нова
//             пошта" до ваших найближчих віділень чи поштоматів із складу у
//             Вінницькій обл. Можлива адресна доставка кур'єром Нової пошти.
//           </p>
//           <p className={css.secondDogovir}>
//             Доставку книжок оплачує замовник за цінами компанії-перевізника.Для
//             замовлень вартістю від 1000 грн доставка є безкоштовною.Сума
//             мінімального замовлення в інтернет-магазині – 100 грн. Вартість
//             доставки залежить від ваги книжок і відстані від Києва до вашого
//             міста. Ми не можемо відповідати за якість роботи поштових
//             перевізників, але у разі проблем із доставкою намагаємося надавати
//             замовникові всіляку підтримку.
//           </p>
//         </div>

//         {/* Оплата */}
//         <div
//           id="payment"
//           className={`${css.buttonGrenDostavka} ${css.anchorTarget}`}
//         >
//           Оплата
//         </div>
//         <div className={css.wrapTwoOffer}>
//           <p className={css.firstDogovir}>
//             На жаль, посилки, відправлені післяплатою, замовники не завжди
//             забирають із пошти, й тоді інтернет-магазинам доводиться оплачувати
//             всі поштові послуги. Для нас це часто вартість надісланої книжки.
//             Тому ми працюємо суворо за ПЕРЕДОПЛАТОЮ на розрахункові рахунки
//             Приватбанку. Реквізити надсилаємо після оформлення замовлення.
//             Повернення товару. Відповідно до Постанови Кабінету Міністрів
//             України від 19 березня 1994 р. № 172 "Про реалізацію окремих
//             положень Закону України "Про захист прав споживачів" друковані
//             видання належної якості не підлягають обміну, поверненню. У випадку
//             виявлення поліграфічного браку книжкової продукції Продавець, за
//             бажанням Покупця, здійснює обмін товару на товар належної якості,
//             або здійснює повернення коштів у розмірі вартості повернутої
//             продукції. Поліграфічний брак – це брак, отриманий внаслідок
//             недотримання технології виробництва, що призводить до перекручування
//             або втрати інформації: розмазування фарби, непродруковування фарби,
//             нечіткий друк, склеєні сторінки, нерівне обрізання, перевернуті
//             аркуші, відсутність аркушів, або їх повторення, невідповідність
//             назви книжки на обкладинці її змісту, тощо).
//           </p>
//           <p className={css.secondDogovir}>
//             Умови замінювання бракованої продукції Видавництво "Час майстрів"
//             гарантує замінювання бракованої продуції на продукцію, що відповідає
//             заявленій якості. Для цього необхідно: 1) відкрити посилку у
//             поштовому відділенні; 2) сфотографувати брак так, щоб було видно
//             книжку повністю та інтер’єр поштового відділення; 3) сфотографувати
//             сам брак зблизька, великим планом; 4) сфотографувати паковання та
//             пошкодження паковання, щоб встановити причини браку: чи не пошкодив
//             книжку перевізник у процесі доставки; 5) якщо пошкодження книжки
//             виникли з вини перевізника, запросити працівника пошти, щоб він це
//             зафіксував; 6) того ж дня, коли посилку було отримано у поштовому
//             відділенні, повідомити видавництво про браковану продукцію. 7)
//             повідомлення про брак надсилайте на електронну адресу
//             lesia.chasmaistriv@gmail.com Увага! Заяви про отримання бракованої
//             продукції видавництво приймає лише в день її отримання і лише з
//             фотографіями на тлі поштового відділення.
//           </p>
//         </div>

//         {/* Самовивіз */}
//         <div
//           id="pickup"
//           className={`${css.buttonGrenDostavka} ${css.anchorTarget}`}
//         >
//           Самовивіз
//         </div>
//         <p className={css.paragInWrapBig}>
//           На сьогоднішній день можливість самовивозу - відсутня.
//         </p>

//         {/* Де побачити наші книги */}
//         <div
//           id="where"
//           className={`${css.buttonGrenWherek} ${css.anchorTarget}`}
//         >
//           Де побачити наші книги
//         </div>
//         <p className={css.mainKuiv}>м. Київ</p>
//         <div className={css.wrapTwoOffer}></div>

//         {/* Книги ЧМ на інших ресурсах */}
//         <div
//           id="other-resources"
//           className={`${css.paragInWrapBig} ${css.anchorTarget}`}
//         >
//           Книги Час майстрів на інших ресурсах
//           <br />
//           Польща ALLEGRO
//           <br />
//           Barnabus Books https://allegro.pl/uzytkownik/Barnabus_Books
//           <br />
//           Книги Час майстрів на "ПРОМі" https://chasmaistriv.in.ua/ua/
//           <br />
//         </div>

//         <div className={css.probil}></div>
//       </div>
//     </div>
//   );
// }
import React, { useCallback, useEffect } from "react";
import css from "./info.module.css";
import { db } from "../../firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";

// map heading style to your exact classes
const headingClass = (style) => {
  switch (style) {
    case "where":
      return css.buttonGrenWherek;
    case "paragraph":
      return css.paragInWrapBig;
    case "button":
    default:
      return css.buttonGrenDostavka;
  }
};

// map nav style to your exact classes
const navBtnClass = (navStyle) => {
  switch (navStyle) {
    case "two":
      return css.aboutCompanyH1Two;
    case "three":
      return css.aboutCompanyH1Thre;
    case "one":
    default:
      return css.aboutCompanyH1One;
  }
};

export default function Delivery() {
  const [sections, setSections] = React.useState([]);
  const [err, setErr] = React.useState("");

  // ====== ідентичний плавний скрол ======
  const SCROLL_MARGIN = 12;

  const getVisibleHeaderHeight = () => {
    const header =
      document.querySelector("[data-fixed-header]") ||
      document.querySelector("header");
    if (!header) return 0;
    const r = header.getBoundingClientRect();
    const visible = Math.max(
      0,
      Math.min(r.height, r.bottom) - Math.max(0, r.top)
    );
    return Math.round(visible);
  };

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const firstHeader = getVisibleHeaderHeight();
    const target =
      el.getBoundingClientRect().top +
      window.pageYOffset -
      (firstHeader + SCROLL_MARGIN);

    window.scrollTo({ top: target, behavior: "smooth" });

    const base = window.location.pathname + window.location.search;
    window.history.replaceState(null, "", `${base}#${id}`);

    setTimeout(() => {
      const nowHeader = getVisibleHeaderHeight();
      const delta =
        el.getBoundingClientRect().top - (nowHeader + SCROLL_MARGIN);
      if (Math.abs(delta) > 1)
        window.scrollBy({ top: delta, behavior: "auto" });
    }, 350);

    setTimeout(() => {
      const nowHeader = getVisibleHeaderHeight();
      const delta =
        el.getBoundingClientRect().top - (nowHeader + SCROLL_MARGIN);
      if (Math.abs(delta) > 1)
        window.scrollBy({ top: delta, behavior: "auto" });
    }, 700);
  }, []);

  const handleAnchor = useCallback(
    (e) => {
      const href = e.currentTarget.getAttribute("href");
      if (!href || !href.startsWith("#")) return;
      e.preventDefault();
      scrollToId(href.slice(1));
    },
    [scrollToId]
  );

  useEffect(() => {
    if (window.location.hash && window.location.hash.startsWith("#")) {
      const id = window.location.hash.slice(1);
      setTimeout(() => scrollToId(id), 0);
    }
  }, [scrollToId]);

  // ====== загрузка секцій ======
  useEffect(() => {
    const q = query(
      collection(db, "pages", "delivery", "sections"),
      orderBy("order", "asc")
    );
    const unsub = onSnapshot(
      q,
      (snap) => setSections(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (e) => setErr(e?.message || String(e))
    );
    return () => unsub();
  }, []);

  return (
    <div className={css.aboutWrapAll}>
      <div className={css.smallWrapAbout}>
        {/* Навігація (той самий контейнер/класи) */}
        <nav className={css.wrapTwoButton} aria-label="Навігація по сторінці">
          {sections
            .filter((s) => s.inNav)
            .map((s) => (
              <a
                key={s.id}
                className={navBtnClass(s.aboutCompanyH1One)}
                href={`#${s.anchor || s.id}`}
                onClick={handleAnchor}
              >
                {s.title}
              </a>
            ))}
        </nav>

        {err && (
          <div style={{ color: "crimson", padding: 8 }}>
            Помилка завантаження: {err}
          </div>
        )}

        {/* Секції по порядку */}
        {sections.map((s) => {
          const headingCls = `${headingClass(s.headingStyle)} ${
            css.anchorTarget
          }`;
          const anchor = s.anchor || s.id;

          return (
            <React.Fragment key={s.id}>
              {/* Заголовок секції */}
              <div id={anchor} className={headingCls}>
                {s.title}
              </div>

              {/* Контент секції — 1:1 з твоєю версткою */}
              {s.layout === "twoCols" ? (
                <div className={css.wrapTwoOffer}>
                  <p
                    className={css.firstDogovir}
                    dangerouslySetInnerHTML={{ __html: s.contentHtml || "" }}
                  />
                  <p
                    className={css.secondDogovir}
                    dangerouslySetInnerHTML={{
                      __html: s.contentHtmlRight || "",
                    }}
                  />
                </div>
              ) : (
                <>
                  {s.singleWrapper === "paragInWrapBig" && (
                    <div
                      className={css.paragInWrapBig}
                      dangerouslySetInnerHTML={{ __html: s.contentHtml || "" }}
                    />
                  )}

                  {s.singleWrapper === "mainKuiv" && (
                    <p
                      className={css.mainKuiv}
                      dangerouslySetInnerHTML={{ __html: s.contentHtml || "" }}
                    />
                  )}

                  {(!s.singleWrapper || s.singleWrapper === "none") && (
                    <div
                      dangerouslySetInnerHTML={{ __html: s.contentHtml || "" }}
                    />
                  )}

                  {s.addEmptyWrapTwoOffer && (
                    <div className={css.wrapTwoOffer} />
                  )}
                </>
              )}
            </React.Fragment>
          );
        })}

        <div className={css.probil} />
      </div>
    </div>
  );
}
